import { render } from "./Ventas.vue?vue&type=template&id=cdadc9f2&scoped=true"
import script from "./Ventas.vue?vue&type=script&lang=js"
export * from "./Ventas.vue?vue&type=script&lang=js"

import "./Ventas.vue?vue&type=style&index=0&id=cdadc9f2&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\fronted_sit_bolivia\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cdadc9f2"]])

export default __exports__